import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'

// Custom Component
import useLoading from "../Loading/useLoading"
import FullScreenDialog from '../Dialog/FullScreenDialog'
import DrawingRelatedItemTable from "./DrawingRelatedItemTable"
import CreateRelatedItemForm from "./CreateRelatedItemForm"

// Custom Style
// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, blackColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingRelatedItemStyle from '../../styles/jss/components/drawingRegister/drawingRelatedItemStyle'

// Global Function
// import {webViewerLoadDocument} from "../../global/webViewerLoadDocument"

// Fetch Data
// import {getRelatedItems} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => drawingRelatedItemStyle(theme))

const DrawingRelatedItem = props => {
	const {drawingDetailRecord, selectedRevisionSeq, setDrawingRefash} = props
	const store = require('store')
	const classes = useStyles()

	// State Variable
	const [relatedItemRefash, setRelatedItemRefash] = useState("")

	// Dialog Contral
	const [createItemDialogOpen, setCreateItemhDialogOpen] = useState(false)


	// Dialog open and close contral
	const createItemDialogHandleOpen = () => {
		setCreateItemhDialogOpen(true)
	}

	const createItemDialogHandleClose = () => {
		setCreateItemhDialogOpen(false)
	}


	// Dialog button declaration
	const createItemDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {

	}, [])


	return (
		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (DrawingDetailRelatedItem.js)"),
		// console.log(drawingDetailRecord),

		// console.log("Selected Revision Seq | Variable: selectedRevisionSeq (DrawingDetailRelatedItem.js)"),
		// console.log(selectedRevisionSeq),

		// console.log("---------------------------------------------------------------------------------"),

		
		<Fragment>
			<div>
				<FullScreenDialog
					open={createItemDialogOpen}
					dialogTitle={"Create Item"}

					formContent={
						<CreateRelatedItemForm
							relatedItemType={"RelatedItems"}
							createMethod={"IN_WEB"}
							drawingDetailRecord={drawingDetailRecord}
							selectedRevisionSeq={selectedRevisionSeq}
							dialogHandleClose={createItemDialogHandleClose}
							setRelatedItemRefash={setRelatedItemRefash}
						/>
					}

					button={createItemDialogBtn}
					handleClose={createItemDialogHandleClose}
				/>
			</div>
			
			<Grid container spacing={1} className={classes.toolMenuBtnGroup}>
				<Grid item>
					<Tooltip title="Create Item">
						<Fab 
							aria-label="create_item"
							color="primary"
							size="small"
							onClick={createItemDialogHandleOpen}
							className={classes.toolMenuBtn}
						>
							<PlaylistAddIcon />
						</Fab>
					</Tooltip>
				</Grid>
			</Grid>

			<div  className={classes.drawingTable}>
				<DrawingRelatedItemTable
					relatedItemType={"RelatedItems"}
					drawingDetailRecord={drawingDetailRecord}
					selectedRevisionSeq={selectedRevisionSeq}
					setDrawingRefash={setDrawingRefash}
					relatedItemRefash={relatedItemRefash}
				/>
			</div>
		</Fragment>
	)
}


export default DrawingRelatedItem